import Button from "../../general/Button"
// import ButtonLink from "../../general/ButtonLink"
import SendEmailContainer from '../cont/SendEmailContainer'
import getData from '../../../functions/getData'
import { AUTH_CAPS, TRANSLATION } from '../../../constants/state'
import { connect } from 'react-redux'
import toJS from '../../../containers/general/toJS'
import hasCap from '../../../functions/hasCap'
import { EDIT_EVENT_CAP } from '../../../constants/caps'
import getDisabledClass from '../../../functions/getDisabledClass'

const mapStateToProps = state => ({
    caps: getData(state, AUTH_CAPS),
    translationStrings: getData(state, [TRANSLATION, 'strings'])
})

const EditEventFormButtons = ({request_id, eventData, totalTotal, settings, currentLang, timezone, debug, hasChanges, transIdMail, transIdConfirmation, transIdPDF, transIdCancel, transIdSubmit, caps, onCancel, onSubmit, onSendMail, translationStrings, hasErrors}) => {
    const disableSave = !hasCap(caps, EDIT_EVENT_CAP)
    const disablePermanently = hasChanges && disableSave

    return (
        <div className={getDisabledClass("buttons-submit-cancel", false, disablePermanently)}>
            <Button
                className="button-cancel"
                spanClassName="text-regular"
                transId={transIdCancel}
                onClick={onCancel}
                disabled={false}
                hideText={false}
                type="button"
            />

            {hasChanges ? (
                <Button
                    className="button-submit"
                    spanClassName="text-regular"
                    transId={transIdSubmit}
                    onClick={onSubmit}
                    disabled={disableSave || hasErrors}
                    hideText={false}
                    type="submit"
                />
            ) : (
                <>
                    <Button
                        className="button-submit"
                        spanClassName="text-regular"
                        transId={transIdConfirmation}
                        onClick={onSendMail}
                        disabled={false}
                        hideText={false}
                        // type="submit"
                    />                    
                    <SendEmailContainer
                        request_id={request_id}
                        eventData={eventData}
                        totalTotal={totalTotal}
                        settings={settings}
                        transIdMail={transIdMail}
                        disableMail={false}
                        currentLang={currentLang}
                        timezone={timezone}
                        debug={debug}
                        translationStrings={translationStrings}
                    />
                    <Button
                        className="button-submit"
                        spanClassName="text-regular"
                        transId={transIdPDF}
                        onClick={()  => window.print()}
                        disabled={false}
                        hideText={false}
                        // type="submit"
                    />
                </>
            )}
        </div>
    )
}

export default connect(mapStateToProps)(toJS(EditEventFormButtons)) 